import React, {useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";
import Header from "./Header.js";
import Home from "./Home.js";
import Checkout from "./Checkout.js";
import Login from "./Login"
import { useStateValue } from './StateProvider';
import {auth} from "./firebase";
import Footer from './Footer';
import C1 from "./C1"
import C2 from "./C2"
import C3 from "./C3"
import C4 from "./C4"
import C5 from "./C5"
import Payment from './Payment'
import {loadStripe} from '@stripe/stripe-js'
import {Elements} from '@stripe/react-stripe-js'
import Orders from './Orders'
import ForgotPassword from './ForgotPassword'
import Profile from './Profile'
import Notfound from './Notfound.png'
import Register from './Register'
import PhoneLogin from './PhoneLogin';
import Dashboard from './components/admin/Dashboard.js';
import EditProduct from "./components/admin/EditProduct.js"
import AddProduct from './components/admin/AddProduct.js';
import SearchedProduct from './pages/SearchedProduct.js';
import ProductCategory from './pages/ProductCategory.js';
import LoadMoreProducts from './components/products/LoadMoreProducts.js';
import InfiniteScrollProducts from './components/products/InfiniteScrollProducts.js';
import BasketPriceUpdater from './components/products/basket/BasketPriceUpdater.js';
import AdminNavbar from './components/admin/AdminNavbar.js';
import ScrollTop from './utility/ScrollTop.js';
import AdminOrders from './components/admin/AdminOrders.js';
import AdminOrder from './components/admin/AdminOrder.js';
const STRIPE_KEY2=process.env.REACT_APP_STRIPE_PK
const promise=loadStripe(`${STRIPE_KEY2}`);
function App() {
  const [{user},dispatch]=useStateValue();

  useEffect(()=>{
    const unsubscribe=auth.onAuthStateChanged((authUser)=>{
      if(authUser){
        dispatch({
          type:"SET_USER",
          user:authUser,
        })
        localStorage.setItem("user",JSON.stringify(authUser.email))
        const cart=JSON.parse(localStorage.getItem(`cart.${authUser.email}`))
        if(cart){
          dispatch({
            type:"FETCH_BASKET",
            item:{cart}
          })
        }else{
          localStorage.setItem(`cart.${authUser.email}`,JSON.stringify([]))
        }
      }else{
        dispatch({
          type:"SET_USER",
          user:null,
        })
        localStorage.setItem("user",JSON.stringify(null))
        const cart=JSON.parse(localStorage.getItem(`cart.null`))
        if(cart){
          dispatch({
            type:"FETCH_BASKET",
            item:{cart}
          })
        }else{
          localStorage.setItem(`cart.null`,JSON.stringify([]))
        }
      }
    });
    return()=>{
      unsubscribe();
    }
  },[user]);

  return (
    <Router>
      <ScrollTop/>
      <div className="app">
        <Switch>
          <Route path="/checkout">
          <BasketPriceUpdater/>
            <Header/>
            <Checkout/>
          </Route>
          <Route path="/login">
            <Login/>
          </Route>
          <Route path="/C1">
            <Header/>
            <C1/>
            <Footer/>
          </Route>
          <Route path="/C2">
            <Header/>
            <C2/>
            <Footer/>
          </Route>
          <Route path="/C3">
            <Header/>
            <C3/>
            <Footer/>
          </Route>
          <Route path="/C4">
            <Header/>
            <C4/>
            <Footer/>
          </Route>
          <Route path="/C5">
            <Header/>
            <C5/>
            <Footer/>
          </Route>
          <Route path="/payment">
            <Header/>
            <Elements stripe={promise}>
            <Payment/>
            </Elements>
          </Route>
          <Route path="/orders">
            <Header/>
            <Orders/>
          </Route>
          <Route path="/ForgotPassword">
            <ForgotPassword/>
          </Route>
          <Route path='/profile'>
          <Header/>
            <Profile/>
          </Route>
          <Route path='/register'>
            <Register/>
          </Route>
          <Route path='/phone'>
            <PhoneLogin/>
          </Route>
          {
            user && user.email === 'sk7816207@gmail.com' ?
              <Route path="/admin/edit/:id">
                <Header />
                <EditProduct />
                <Footer />
              </Route> : ''

          }
          {
            user && user.email === 'sk7816207@gmail.com' ? <Route exact path="/admin">
              <AdminNavbar/>
              <Dashboard />
              <Footer />
            </Route> : ''


          }
          {
            user && user.email === 'sk7816207@gmail.com' ?
              <Route path="/admin/add-product">
                <Header />
                <AddProduct />
                <Footer />
              </Route>
              : ''
          }
          {
            user && user.email === 'sk7816207@gmail.com' ?
              <Route exact path="/admin/orders">
                <AdminNavbar/>
                <AdminOrders />
                <Footer />
              </Route>
              : ''
          }
          {
            user && user.email === 'sk7816207@gmail.com' ?
              <Route path="/admin/orders/:id">
                <AdminNavbar/>
                <AdminOrder />
                <Footer />
              </Route>
              : ''
          }
          <Route path="/search/products/:searchText">
          <Header/>
            <SearchedProduct/>
            <Footer/>
          </Route>
          <Route path="/category/:name">
          <Header/>
           <ProductCategory/> 
          <Footer/>
          </Route>
          <Route exact path="/all">
            <Header/>
              <LoadMoreProducts/>
              {/* <InfiniteScrollProducts/> */}
          </Route>
          <Route exact path="/">
            <Header/>
            <Home/>
            <Footer/>
          </Route>
          <Route>
            <div className='container'>
              <div className='mt-1'>
                <center><img src={Notfound} alt=''/></center>
                <p className='text-center'><span className='text-center font-weight-bold'>Sorry, that page doesn't exists.</span></p>
                <Link to='/'>
                <p className='text-center'>Back to home</p>
                </Link>
              </div>
            
            </div>
          </Route>
          
        </Switch>
      </div>
    </Router>
 
  );
}

export default App;
